// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gNldh","col":"styles_col__Y8GXQ"};